/**
 * Created by ws7 on 2017/6/12.
 */


export default {
    list: []
};